import type { ReactNode } from 'react'

import '@/Ship/Templates/Form/BaseViewFieldTemplate.css'

interface ViewRowProps {
    label: ReactNode
    /** Значення; порожнє (див. isEmptyValue) показується як «—» приглушеним кольором */
    children?: ReactNode
    className?: string
}

/** Порожнє: null/undefined/false, порожній рядок або «—» (з пробілами). 0 — значення */
export const isEmptyValue = (value: unknown): boolean => {
    if (value === null || value === undefined || value === false) return true
    if (typeof value !== 'string') return false
    const trimmed = value.trim()
    return trimmed === '' || trimmed === '-' || trimmed === '—'
}

/**
 * Рядок «підпис — значення» у стилі режиму перегляду форми (BaseViewFieldTemplate), але для
 * статичного значення, а не поля форми: у власних шаблонах карток, де дані беруться з
 * відповіді напряму (задача, заявка). Розмітка й класи ті самі, тож вигляд і адаптив спільні.
 */
export const ViewRow = ({ label, children, className }: ViewRowProps) => {
    const isEmpty = isEmptyValue(children)
    return (
        <div className={`form-field-view${className ? ` ${className}` : ''}`}>
            <div className="field-view-label">{label}</div>
            <div className={`field-view-value${isEmpty ? ' is-empty' : ''}`}>{isEmpty ? '—' : children}</div>
        </div>
    )
}
